
export default {
  name: "ArticleCard",

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  components: {
    MessageMore: () => import("~/components/UI/MessageMore")
  }
}
